<div class="graph-page">
  <div class="graph-header">
    <div class="graph-title">
      <a class="back-link" [routerLink]="['/agent/crm']">&larr; CRM</a>
      <h3>CRM Graph</h3>
      <span class="graph-stats" *ngIf="!loading && !error">{{ nodeCount }} nodes &middot; {{ edgeCount }} edges</span>
    </div>

    <div class="graph-controls" *ngIf="!loading && !error">
      <input
        type="text"
        class="search-input"
        placeholder="Search nodes..."
        [(ngModel)]="searchTerm"
        (keyup.enter)="search()" />
      <button class="site-button black" (click)="search()">Search</button>
      <button class="site-button black" (click)="fit()">Fit</button>
      <button class="site-button black" (click)="relayout()">Re-layout</button>
      <label class="toggle-label">
        <input type="checkbox" [(ngModel)]="showUnconnected" (change)="toggleUnconnected()" />
        Show unconnected
      </label>
    </div>

    <div class="legend" *ngIf="!loading && !error">
      <span class="legend-item"><span class="legend-dot creator"></span>Creator</span>
      <span class="legend-item"><span class="legend-dot agency"></span>Agency</span>
      <span class="legend-item"><span class="legend-dot brand"></span>Brand</span>
    </div>
  </div>

  <div *ngIf="searchError" class="search-error">{{ searchError }}</div>
  <div *ngIf="loading" class="loading-message">Loading graph data...</div>
  <div *ngIf="error" class="error-message">{{ error }}</div>

  <div class="graph-body" [class.hidden]="loading || error">
    <div #graphContainer class="graph-container"></div>

    <div class="info-panel" *ngIf="selectedNode">
      <div class="info-header">
        <span class="info-dot" [style.background]="selectedNode.color"></span>
        <div class="info-title">
          <div class="info-name">{{ selectedNode.label }}</div>
          <div class="info-kind">{{ selectedNode.kindLabel }}</div>
        </div>
        <button class="close-btn" (click)="clearSelection()">&#x2715;</button>
      </div>

      <div class="info-total">
        <span class="info-total-label">Total Rate</span>
        <span class="info-total-value">{{ selectedNode.totalRate | currency:'USD':'symbol':'1.0-0' }}</span>
      </div>

      <div class="info-campaigns-header">
        Campaigns ({{ selectedNode.campaigns.length }})
      </div>
      <div class="info-campaigns">
        <a
          class="campaign-row"
          *ngFor="let campaign of selectedNode.campaigns"
          [routerLink]="['/agent/campaigns', campaign.id]">
          <span class="campaign-name">{{ campaign.name }}</span>
          <span class="campaign-rate">{{ campaign.rate | currency:'USD':'symbol':'1.0-0' }}</span>
        </a>
        <div *ngIf="selectedNode.campaigns.length === 0" class="no-campaigns">No campaigns linked.</div>
      </div>
    </div>
  </div>
</div>
